import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Brush,
  LabelList,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { IChartProps, StickyTooltip } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import { labelFormatterPercentile } from '../../../../../shared/formatters/formatters';
import { SelicGraphicChartData } from './types';

export const SelicRate: React.FC = () => {
  const { requesStatusMarketCycle, chartsDataMarketCycle } = useSelector(
    (state: any) => state.marketCycleState
  );

  return (
    <ChartCard
      data={chartsDataMarketCycle['selicRate']}
      Chart={SelicRateChart}
      cy={'SelicRate'}
      id={'selicRate'}
      requestStatus={requesStatusMarketCycle['selicRate']}
    />
  );
};

const SelicRateChart: React.FC<IChartProps<SelicGraphicChartData[]>> = ({
  data,
  cy,
  id,
}) => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../../nls/${preference.language.id}.json`);
  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [recordTooltip, setRecordTooltip] = useState<JSX.Element | null>(null);
  const [stopChange, setStopChange] = useState<boolean>(false);
  const formatterFunctions = [labelFormatterPercentile];
  return (
    <ResponsiveContainer data-cy={`SelicRate${cy}`}>
      <LineChart
        id={id}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <XAxis
          dataKey="period"
          padding={{ left: 30, right: 30 }}
          domain={['auto', 'dataMax']}
        />
        <Tooltip
          wrapperStyle={{ visibility: 'visible' }}
          content={
            <StickyTooltip
              hasClicked={hasClicked}
              recordTooltip={recordTooltip}
              setRecordTooltip={setRecordTooltip}
              stopChange={stopChange}
              setStopChange={setStopChange}
              formatterFunctions={formatterFunctions}
            />
          }
        />
        <YAxis tickFormatter={labelFormatterPercentile} />
        <Line
          type="monotone"
          isAnimationActive={false}
          name={nls.charts.selicRate.title}
          stroke="#3F205A"
          dataKey="value"
        />
        <Brush dataKey="id" height={30} stroke="#8884d8" />
      </LineChart>
    </ResponsiveContainer>
  );
};
